/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Wpm_LabelInputs */

const en_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Words Per Minute (WPM)`)
};

const fr_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mots maximum par minute (WPM)`)
};

const de_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Wörter pro Minute (WPM)`)
};

const it_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di parole al minuto (WPM)`)
};

const ru_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальная скорость печати (слов в минуту)`)
};

const es_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de palabras por minuto (WPM)`)
};

const zh_cn2_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每分钟最大字数 (WPM)`)
};

const ja_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1分あたりの最大単語数（WPM）`)
};

const hi_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति मिनट अधिकतम शब्द (WPM)`)
};

const pt_pt2_style_guide_manager_max_wpm_label = /** @type {(inputs: Style_Guide_Manager_Max_Wpm_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de palavras por minuto (PPM)`)
};

/**
* | output |
* | --- |
* | "Maximum Words Per Minute (WPM)" |
*
* @param {Style_Guide_Manager_Max_Wpm_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_wpm_label = /** @type {((inputs?: Style_Guide_Manager_Max_Wpm_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Wpm_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_max_wpm_label(inputs)
	if (locale === "de") return de_style_guide_manager_max_wpm_label(inputs)
	if (locale === "it") return it_style_guide_manager_max_wpm_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_max_wpm_label(inputs)
	if (locale === "es") return es_style_guide_manager_max_wpm_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_max_wpm_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_max_wpm_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_max_wpm_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_max_wpm_label(inputs)
	return en_style_guide_manager_max_wpm_label(inputs)
});